var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshblueicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0825 1.90937C9.90437 0.73125 8.2875 0 6.49187 0C2.90062 0 0 2.90875 0 6.5C0 10.0913 2.90062 13 6.49187 13C9.5225 13 12.0494 10.9281 12.7725 8.125H11.0825C10.4162 10.0181 8.6125 11.375 6.49187 11.375C3.8025 11.375 1.61687 9.18937 1.61687 6.5C1.61687 3.81063 3.8025 1.625 6.49187 1.625C7.84062 1.625 9.04312 2.18563 9.92062 3.07125L7.30437 5.6875H12.9919V0L11.0825 1.90937Z",
    fill: "#003C88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshblueicon);
export default __webpack_public_path__ + "static/media/refreshblueicon.e2babbc114a86063f2ae23548dda0370.svg";
export { ForwardRef as ReactComponent };